import { Component, OnInit, ViewChild, ElementRef, Renderer } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import Utils from '../shared/utility';
import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { ClientService } from '../create-client/client.service';

import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-create-advisor',
  templateUrl: './create-advisor.component.html',
  styleUrls: ['./create-advisor.component.css']
})
export class CreateAdvisorComponent implements OnInit {

public error: string; 

public modalSubscription;
public loadingSubscription;

public allStates: any[] = Utils.allStates.filter(s => s.abbreviation !== 'NA');//Utils.allStates;

public currentAddEditClientScreen: Number = 0;
public previousAddEditClientScreen: Number = 0;

public modalName: string;
private ID: number; // ID of whatever entity we need to get data for

public client: any = {};

public isSelectingAdvisor: boolean = false;
public organizations: any;
public advisors: any;
public selectedOrganization: any;
public selectedAdvisors: any;
public selectedAdvisor: any;
public advisorObject: any;
public isEditClient: boolean = false;
public isCreateClient: boolean = false;
public isVisible: boolean;

public uneditableAdvisorInputsMessage: string = "Open the support icon in the bottom right of your screen to contact us about updating your account.";

constructor(private modalService: ModalService, private clientService: ClientService, private globalService: GlobalService, private snackBarService: SnackBarService, 
  private router: Router, private sanitizer: DomSanitizer, private _formBuilder: FormBuilder) {
    
    //this.ID = 0;
    const currentNav = this.router.getCurrentNavigation();
    this.ID = (currentNav && currentNav.extras && currentNav.extras.state && currentNav.extras.state.ID) ? currentNav.extras.state.ID : 0;
    
    this.router.events
    .filter(event => event instanceof NavigationEnd)
    .subscribe(event => this.handleSidebarStatus((event as NavigationEnd).url));
    
    this.modalSubscription = clientService.modal$.subscribe(modal => {
      //this.isEditClient = "True";
      this.modalName = modal.modalName;
      //this.modalData = modal.data;
      this.ID = modal.data.ID;
      this.initialCallFromConstructor();
      // this.open();
      this.isVisible = true;

    });

    if (this.ID == 0 && this.isCreateClient) {
      this.isEditClient = false;
      this.currentAddEditClientScreen = 0;
    
    }
    if (this.isEditClient) {
      this.isCreateClient = false;
      this.ID = Number(localStorage.getItem('selectedAdvisor'));
    }

    this.initialCallFromConstructor();
    this.isVisible = true;
}

handleSidebarStatus(url) {
  if(url.includes('/advisors/create')){
    this.isCreateClient = true;
  } else {
    this.isEditClient = true;
  }
}

initialCallFromConstructor() {
    this.getAdvisorInfo();
}

profileInfo: FormGroup;
contactInfo: FormGroup;
ngOnInit(): void {

  //set forms
  this.profileInfo = new FormGroup({
    firstName: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(24), Validators.pattern('^[a-zA-Z \-\']+')]),
    lastName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(25), Validators.pattern('^[a-zA-Z \-\']+')]),
    state: new FormControl(''),    
    city: new FormControl(''),       
    address: new FormControl(''),       
    zip: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.minLength(5), Validators.maxLength(5)]),
    firmName: new FormControl(''),
    doNotDisplayAdvisorName: new FormControl(false)
  });

  this.profileInfo.get('doNotDisplayAdvisorName').valueChanges.subscribe(checked => {
    const optionalControls = ['firmName', 'address', 'city', 'state', 'zip'];
    optionalControls.forEach(controlName => {
      const control = this.profileInfo.get(controlName);
      if (checked) {
        control.disable();
      } else {
        control.enable();
      }
    });
  });

  this.contactInfo = new FormGroup({
    phone: new FormControl('', [Validators.required, Validators.minLength(14), Validators.maxLength(14)]),
    email: new FormControl('', [Validators.required, Validators.email]),
    firmID: new FormControl('', [Validators.required]),
    npn: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.minLength(5)]),
  });
 
  //get/check for Advisor info
  /* if(this.ID > 0){
    console.log('id passed:', this.ID);
    this.getAdvisorInfo();
  } */
  this.getAdvisorInfo();
}

phoneKeyPress(event: any) {
  const pattern = /[0-9\+\-\ ]/;
  let inputChar = String.fromCharCode(event.charCode);
  if (event.keyCode != 8 && !pattern.test(inputChar)) {
    event.preventDefault();
  }
}

onPhoneInputChange(event, backspace) {
  let newVal = event.replace(/\D/g, '');
  if (backspace && newVal.length <= 6) {
    newVal = newVal.substring(0, newVal.length - 1);
  }
  if (newVal.length === 0) {
    newVal = '';
  } else if (newVal.length <= 3) {
    newVal = newVal.replace(/^(\d{0,3})/, '($1)');
  } else if (newVal.length <= 6) {
    newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
  } else if (newVal.length <= 10) {
    newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
  } else {
    newVal = newVal.substring(0, 10);
    newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
  }
  //this.ngControl.valueAccessor.writeValue(newVal);
  this.contactInfo.controls["phone"].setValue(newVal);

}

updateAddEditClientScreen(page) {
  console.log('page', page);

  if(page == 0 && !this.isSelectingAdvisor){
    this.isSelectingAdvisor = true;
    //return;
  } else {
    this.isSelectingAdvisor = false
  }

  if(page == 1){
    //going to page 1
    if(this.profileInfo.invalid){
      return;
    }
  }

  if (page !== this.currentAddEditClientScreen) {
    this.previousAddEditClientScreen = this.currentAddEditClientScreen;
    this.currentAddEditClientScreen = page;
   
  }
}

formatToString(section){  
  if(section == 'firstName'){
    this.profileInfo.controls['firstName'].patchValue(Utils.formatToString(this.profileInfo.value.firstName));
  } else if(section == 'lastName'){
    this.profileInfo.controls['lastName'].patchValue(Utils.formatToString(this.profileInfo.value.lastName));
  }
}

saveAdvisor(){

  if(this.profileInfo.invalid || this.contactInfo.invalid){
    return;
  }

  const profileRaw = this.profileInfo.getRawValue();
  const contactRaw = this.contactInfo.getRawValue();

  var UserModel = {
    FirstName: profileRaw.firstName,
    LastName: profileRaw.lastName,
    Address: profileRaw.address,
    City: profileRaw.city,
    State: profileRaw.state,
    Zip: profileRaw.zip,
    FirmName: profileRaw.firmName,
    DoNotDisplayAdvisorName: profileRaw.doNotDisplayAdvisorName,
    
    Email: contactRaw.email,
    Phone: contactRaw.phone,
    //FirmID: contactRaw.firmID,
    NPN: contactRaw.npn,
    OrganizationID: contactRaw.firmID,
    //Number(localStorage.getItem('orgID')),
    ID: this.ID, //advisor.id
    UserID: this.ID
  }

  this.globalService.createAdvisor(UserModel)
  .subscribe(
    resp => {
      if (resp.type != 0) {
        this.snackBarService.add('Advisor has been updated', 0);
        this.router.navigate(['advisors']);
      } else {
        this.snackBarService.add('An error occured updating this advisor.', 1);
      }

    },
    error => {
      this.snackBarService.add('There was an issue updating this advisor, please try again later.', 1);
      this.error = <any>error;
    });
}

getAdvisorInfo(): void {

  if(this.ID > 0){
  this.globalService.getAdvisorData(Number(this.ID))
    .subscribe(
      advisor => {
        console.log('advisor info', advisor);
        this.profileInfo.controls['firstName'].setValue(advisor.FirstName);
        this.profileInfo.controls['lastName'].setValue(advisor.LastName);
        this.profileInfo.controls['address'].setValue(advisor.Address);
        this.profileInfo.controls['city'].setValue(advisor.City);
        this.profileInfo.controls['state'].setValue(advisor.State);
        this.profileInfo.controls['zip'].setValue(advisor.Zip);
        this.profileInfo.controls['firmName'].setValue(advisor.FirmName || '');
        this.profileInfo.controls['doNotDisplayAdvisorName'].setValue(advisor.DoNotDisplayAdvisorName || false);

        this.contactInfo.controls['email'].setValue(advisor.Email);
        this.contactInfo.controls['phone'].setValue(advisor.Phone);
        this.contactInfo.controls['firmID'].setValue(advisor.OrganizationID);
        this.contactInfo.controls['npn'].setValue(advisor.NPN);

        //DO WE NEED THIS ?
        //if (Number(localStorage.getItem('roleId')) == 1 || Number(localStorage.getItem('roleId')) == 2) {
          this.globalService.getOrganizationsData()
            .subscribe(
              organizations => {
               this.organizations = organizations;
               if(this.organizations.length == 1){
                this.contactInfo.controls['firmID'].setValue(this.organizations[0].ID);
               } else {
                //this.contactInfo.controls['firmID'].setValue(advisor.FirmID);
               }
              },
              error => this.error = <any>error);

        //}
      },
      error => this.error = <any>error);
  
      /*this.globalService.getClientData(this.ID, 4)
          .subscribe(
              client => {
                this.client = client;
              },
              error => this.error = <any>error); */
    } else {
      //No Advisor selected
      this.globalService.getOrganizationsData()
      .subscribe(
        organizations => {

          this.organizations = organizations;
          if(this.organizations.length == 1){
            this.contactInfo.controls['firmID'].setValue(this.organizations[0].ID);
          }
        },
        error => this.error = <any>error);
    }
}

validateString(val, isRequired) {
  var regex = /^[a-zA-Z ]{2,25}$/;
  return val ? regex.test(val) : !isRequired;
}

validatePhoneNumber(val, isRequired) {
  val = val ? val.toString() : '';
  var numbers = val ? val.match(/\d/g) : '';
  return val ? numbers.length === 10 : !isRequired;
}

validateZip(val, isRequired) {
  return true;
}

validateCurrency(val, min, max, isRequired) {
  val = val ? val.toString() : '';
  var numbers = val ? val.match(/\d/g).join('') : '';
  return val ? (numbers >= min && numbers < max) ? true : false : !isRequired;
}

validateEmail(val, isRequired) {
  var regex = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
  return val ? regex.test(val) : !isRequired;
}


validateDate(val, isRequired) {
  var regex = /^([0-9]{1}|[0-9]{2})\/([0-9]{1}|[0-9]{2})\/([0-9]{4})$/;
  return val ? regex.test(val) : !isRequired;
}

validatePercent(val, min, max, isRequired) {
  val = val ? val.toString() : '';
  var numbers = val ? val.match(/\d/g).join('') : '';
  return val ? (numbers >= min && numbers < max) ? true : false : !isRequired;
}

validateNumber(val, min, max, isRequired) {
  val = val ? val.toString() : '';
  var numbers = val ? val.match(/\d/g).join('') : '';
  return val ? (numbers >= min && numbers < max) ? true : false : !isRequired;
}

getNumber(val) {
  val = val ? val.toString() : '';
  val = val.replace('$', '').replace(',', '');
  var numbers = val ? val.match(/\d/g).join('') : '';
  return val ? numbers : 0
}

formatString(model, field) {
  if (model[field])
    model[field] = model[field].charAt(0).toUpperCase() + model[field].slice(1);
}




formatNumber(model, field) {
  var numbers = model[field] ? model[field].match(/\d/g) : '';
  model[field] = numbers.join('');
}

formatPercent(model, field, e) {
  if (model[field]) {
    model[field] = model[field].toString();
    var numbers = model[field] ? model[field].match(/\d/g) : '';
    if (e.keyCode && (e.keyCode == 8 || e.keyCode == 46))
      numbers.pop();

    model[field] = numbers.join('') + '%';
  }
}

formatCurrency(model, field) {
  if (model[field]) {
    model[field] = model[field].toString();
    var numbers = model[field] ? model[field].match(/\d/g) : '';
    model[field] = '$' + numbers.join('').toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
}

formatCurrencyV2(amount) {
  amount = amount.toString().replace(/,/g, "").replace("$", "");
  return Utils.formatToCurrency(amount);
}

formatPhoneNumber(model, field) {
  if (model[field]) {
    model[field] = model[field].toString();
    var numbers = model[field] ? model[field].match(/\d/g) : '';
    if (numbers.length < 3) {
      model[field] = "(" + numbers.join('');
    } else if (numbers.length < 4) {
      model[field] = "(" + numbers.join('') + ")";
    } else if (numbers.length < 7) {
      model[field] = "(" + numbers.join('').substring(0, 3) + ") " + numbers.join('').substring(3, numbers.length);
    } else if (numbers.length >= 7) {
      model[field] = "(" + numbers.join('').substring(0, 3) + ") " + numbers.join('').substring(3, 6) + "-" + numbers.join('').substring(6, 10);
    }
  }

}

ngOnDestroy() {
  
}


}
